<div class="grid h-full min-h-0 grid-rows-[minmax(0,1fr)_auto] overflow-hidden">
  <div class="min-h-0 overflow-hidden">
    <div
      #scrollContent
      class="h-full overflow-y-auto overscroll-contain pr-1 pb-0.5"
      (scroll)="updateScrollState()"
    >
      <div
        class="mb-1 text-[28px] leading-none font-bold text-black dark:text-white"
      >
        {{ "WORK_QUICK_COMPLETION_TITLE" | translate }}
      </div>
      <div class="mb-3 text-sm text-grey dark:text-lightGrey">
        {{ "WORK_QUICK_COMPLETION_PROMPT_INTRO" | translate }}
        <span class="font-bold text-black italic dark:text-white">{{
          title
        }}</span>
      </div>

      <div
        class="mb-1 grid grid-cols-3 gap-1 rounded-xl bg-whitegrey p-1 dark:bg-black"
      >
        @for (option of options; track option.status) {
        <button
          type="button"
          class="min-h-[46px] cursor-pointer rounded-lg px-1 text-sm font-bold transition-colors duration-150 mobile:px-2 mobile:text-base"
          [ngClass]="{
            'bg-black text-white dark:bg-white dark:text-black':
              status === option.status,
            'text-grey hover:bg-white dark:text-lightGrey dark:hover:bg-black-dark-light':
              status !== option.status
          }"
          [disabled]="isSubmitting"
          (click)="setStatus(option.status)"
        >
          {{
            (option.status === "completed"
              ? completedLabelKey
              : option.labelKey
            ) | translate
          }}
        </button>
        }
      </div>

      @if (shouldShowCompletionMetadataLoader) {
      <div
        class="mb-1 flex min-h-[116px] items-center justify-center mobile:mb-3"
      >
        <img
          src="./assets/images/loading.svg"
          alt=""
          class="h-6 w-6"
          aria-hidden="true"
        />
      </div>
      } @else { @if (showVolumeControls) {
      <div
        class="mb-1 rounded-lg border border-borders-dark p-2 mobile:mb-3 dark:border-borders-darker"
      >
        <div class="mb-2 flex items-center justify-between gap-2 text-sm">
          <span class="font-bold text-black dark:text-white">
            {{ "WORK_QUICK_COMPLETION_VOLUME" | translate }}
          </span>
          <span class="text-grey dark:text-lightGrey">
            {{ volumeValue }} / {{ totalVolumes }}
          </span>
        </div>
        <input
          appStyledRange
          type="range"
          min="0"
          [max]="volumeChoices.length - 1"
          [ngModel]="volumeChoices.indexOf(volumeValue)"
          (ngModelChange)="onVolumeChange($event)"
          class="w-full cursor-pointer"
          [disabled]="isSubmitting || isMetadataLoading"
        />
      </div>
      } @if (showSeriesControls) {
      <div
        class="mb-1 rounded-lg border border-borders-dark p-2 mobile:mb-3 dark:border-borders-darker"
      >
        <div class="mb-3">
          <div class="mb-2 flex items-center justify-between gap-2 text-sm">
            <span class="font-bold text-black dark:text-white">
              {{ "WORK_QUICK_COMPLETION_SEASON" | translate }}
            </span>
            <span class="text-grey dark:text-lightGrey">
              {{ selectedSeason }} / {{ totalSeriesSeasons }}
            </span>
          </div>
          <input
            appStyledRange
            type="range"
            min="0"
            [max]="seasonChoices.length - 1"
            [ngModel]="seasonChoices.indexOf(selectedSeason)"
            (ngModelChange)="onSeasonChange($event)"
            class="w-full cursor-pointer"
            [disabled]="isSubmitting || isMetadataLoading"
          />
        </div>

        <div>
          <div class="mb-2 flex items-center justify-between gap-2 text-sm">
            <span class="font-bold text-black dark:text-white">
              {{ "WORK_QUICK_COMPLETION_EPISODE" | translate }}
            </span>
            <span class="text-grey dark:text-lightGrey">
              {{ selectedEpisode }} / {{ totalSeriesEpisodes }}
            </span>
          </div>
          <input
            appStyledRange
            type="range"
            min="0"
            [max]="episodeChoices.length - 1"
            [ngModel]="episodeChoices.indexOf(selectedEpisode)"
            (ngModelChange)="onEpisodeChange($event)"
            class="w-full cursor-pointer"
            [disabled]="isSubmitting || isMetadataLoading"
          />
        </div>
      </div>
      } }

      <section
        class="mb-1 rounded-lg border border-borders-dark p-2 mobile:mb-3 dark:border-borders-darker"
      >
        <div class="mb-1 text-sm font-bold text-black dark:text-white">
          {{ "DISCOVERY_DATE" | translate }}
        </div>
        <mat-form-field class="w-full">
          <input
            matInput
            required
            [matDatepicker]="discoveryDatePicker"
            [max]="today"
            [ngModel]="discoveryDate"
            [disabled]="discoveredOnRelease || isSubmitting"
            [placeholder]="'PICK_A_DATE' | translate"
            (ngModelChange)="onDiscoveryDateChange($event)"
          />
          <mat-hint class="text-grey dark:text-borders-dark">
            DD/MM/YYYY
          </mat-hint>
          <mat-datepicker-toggle
            matSuffix
            [for]="discoveryDatePicker"
            [disabled]="discoveredOnRelease || isSubmitting"
          ></mat-datepicker-toggle>
          <mat-datepicker #discoveryDatePicker></mat-datepicker>
        </mat-form-field>
        <mat-checkbox
          class="white-border-checkbox mt-1 block"
          [ngModel]="discoveredOnRelease"
          [disabled]="isSubmitting || !workReleaseDate"
          (ngModelChange)="onDiscoveredOnReleaseChange($event)"
        >
          {{ "WORK_DISCOVERED_ON_RELEASE" | translate }}
        </mat-checkbox>
      </section>

      <div
        class="rounded-lg border border-borders-dark p-2 dark:border-borders-darker"
      >
        <div class="mb-2 flex items-center justify-between gap-2">
          <div
            class="text-sm font-bold uppercase text-grey dark:text-lightGrey"
          >
            {{ companionTitleKey | translate }}
          </div>
          <button
            type="button"
            class="btn btn-small btn-transparent !m-0 !rounded-full"
            (click)="openCompanionFlow()"
          >
            + {{ "ADD" | translate }}
          </button>
        </div>

        @if (activeCompanions.length > 0) {
        <div class="flex flex-wrap gap-1.5">
          @for (companion of activeCompanions; track trackCompanion($index,
          companion)) {
          <app-user-chip
            [label]="getCompanionDisplayName(companion)"
            [picture]="companion.target.picture"
            [avatarSize]="28"
            [removable]="true"
            [disabled]="isSubmitting"
            [removeLabel]="'REMOVE' | translate"
            (requestRemove)="removeCompanion(companion)"
          ></app-user-chip>
          }
        </div>
        } @else {
        <div class="text-sm text-grey dark:text-lightGrey">
          {{ "WORK_QUICK_COMPLETION_NO_COMPANION" | translate }}
        </div>
        }
      </div>

      @if (isSaved) {
      <div class="mb-2 text-sm font-bold text-completed">
        {{ "WORK_QUICK_COMPLETION_SAVED" | translate }}
      </div>
      }
    </div>
  </div>

  <div
    class="relative z-10 shrink-0 bg-white pt-1 pb-0.5 mobile:pt-2 mobile:pb-0 dark:bg-black-dark"
  >
    <div
      class="pointer-events-none absolute inset-x-0 -top-4 h-4 bg-linear-to-t from-white via-white/85 to-transparent transition-opacity duration-150 dark:from-black-dark dark:via-black-dark/85"
      [class.opacity-0]="!hasScrollableContent || isContentScrolledToBottom"
      aria-hidden="true"
    ></div>

    <button
      type="button"
      class="mb-0.5 flex min-h-[16px] w-full cursor-pointer items-center justify-center gap-1 bg-transparent text-xs leading-4 font-semibold text-grey transition-all duration-150 hover:text-black disabled:cursor-default mobile:mb-1 dark:text-lightGrey dark:hover:text-white"
      [disabled]="!hasScrollableContent || isContentScrolledToBottom"
      [class.opacity-0]="!hasScrollableContent || isContentScrolledToBottom"
      [attr.aria-hidden]="!hasScrollableContent || isContentScrolledToBottom"
      (click)="scrollToCompanions()"
    >
      {{ "WORK_QUICK_COMPLETION_SCROLL_COMPANIONS" | translate }}
      <span
        class="block h-3.5 w-3.5 rotate-90 bg-grey mask-[url(/assets/images/icons/chevron-right.svg)] mask-center mask-no-repeat mask-size-[14px_14px] dark:bg-lightGrey"
        aria-hidden="true"
      ></span>
    </button>

    <div class="flex justify-center">
      <button
        type="button"
        class="btn btn-grad !m-0 !flex !min-h-[50px] !max-w-none items-center justify-center gap-1.5 !px-4 !text-base"
        [disabled]="!canSubmit"
        [attr.aria-busy]="isSubmitting || isMetadataLoading"
        (click)="saveCompletion()"
      >
        @if (isSubmitting || isMetadataLoading) {
        <img
          src="./assets/images/loading.svg"
          alt=""
          class="h-3 w-3 shrink-0"
          aria-hidden="true"
        />
        }
        <span aria-live="polite">
          @if (isSubmitting) {
          {{ "SAVING" | translate }}
          } @else if (isMetadataLoading) {
          {{ "LOADING..." | translate }}
          } @else {
          {{ "WORK_QUICK_COMPLETION_SAVE" | translate }}
          }
        </span>
      </button>
    </div>

    <a
      href=""
      class="mt-2 block text-center text-sm font-semibold text-grey underline decoration-grey/40 underline-offset-4 hover:text-black dark:text-lightGrey dark:hover:text-white"
      (click)="$event.preventDefault(); requestRemove.emit()"
    >
      {{ "WORK_QUICK_PROMPT_REMOVE_LINK" | translate }}
    </a>
  </div>
</div>
